import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Login',
        component: () => import('../views/weather.vue'),
        meta: {
            title: '首府天气'
        },
    },
    {
        path: '/quanjiang',
        component: () => import('../views/quanjiang.vue'),
        meta: {
            title: '全疆天气'
        },
    },
    {
        path: '/jingqu',
        component: () => import('../views/jingqu.vue'),
        meta: {
            title: '景区天气'
        },
    },
    {
        path: '/road',
        component: () => import('../views/road.vue'),
        meta: {
            title: '公路预报'
        },
    },
    {
        path: '/real',
        component: () => import('../views/real.vue'),
        meta: {
            title: '实况天气'
        },
    },
    {
        path: '/realSort',
        component: () => import('../views/realSort.vue'),
        meta: {
            title: '统计排名'
        },
    },
    {
        path: '/radar',
        component: () => import('../views/radar.vue'),
        meta: {
            title: '雷达监测'
        },
    },
    {
        path: '/weixing',
        component: () => import('../views/weixing.vue'),
        meta: {
            title: '卫星云图'
        },
    },
    {
        path: '/warning',
        component: () => import('../views/warning.vue'),
        meta: {
            title: '预警信号'
        },
    },
    {
        path: '/city',
        component: () => import('../views/city.vue'),
        meta: {
            title: '城市选择'
        },
    },
    {
        path: '/city/weather/:code/:name',
        component: () => import('../views/cityWeather.vue'),
        meta: {
            title: '城市选择'
        },
    },
    {
        path: '/chuxing',
        component: () => import('../views/chuXing.vue'),
        meta: {
            title: '出行天气'
        },
    },
    {
        path: '/weibo',
        component: () => import('../views/weibo.vue'),
        meta: {
            title: '官方微博'
        },
    },
    {
        path: '/upload',
        component: () => import('../views/upload.vue'),
        meta: {
            title: '灾情反馈'
        },
    },
    {
        path: '/kepu',
        component: () => import('../views/kepu.vue'),
        meta: {
            title: '气象科普'
        },
    },
    {
        path: '/kepu/list/:src',
        component: () => import('../views/kepuList.vue'),
        meta: {
            title: '科普列表'
        },
    },
];

export default new VueRouter({
    base:'/resources/wechat/',
    routes
});